module.exports = {
  message: {
    service_desc: 'Use the utility to swap COS between different formats including <strong>native COS, and ERC-20.</strong>',
    choose_token_type: 'Choose your cos format',
    fee_tips: 'If the number of swap is greater than 500, 50 cos will be charged as a handling fee \' +\n' +
      '        \'If it is less than 500, 10% of the swap amount will be charged as a handling fee.',
    token_type_erc20_to_bep2: 'ERC-20 to BEP2',
    token_type_erc20_to_native: 'ERC-20 to native COS',
    token_type_bep2_to_erc20: 'BEP2 to ERC-20',
    token_type_bep2_to_native: 'BEP2 to native COS',
    token_type_native_to_erc20: 'native COS to ERC-20',
    token_type_native_to_bep2: 'native COS to BEP2',
    enter_address: 'Enter your address or account',
    enter_exchange_memo: 'Enter your Exchange memo',
    create_account_tips: 'Don\'t have an account? Create one',
    next_btn: 'NEXT',
    start_over_btn: 'Start over',
    ready_to_swap: 'Ready to swap',
    transfer_prefix: 'Transfer your {token} to',
    address: 'Address',
    memo: 'Memo',
    auto_swap_desc: 'Make sure you enter the ADDRESS and MEMO correctly.Swap token utility will send out the corresponding amount of COS token below wallet once receiving your token.<strong>The process may take about 5 minutes<strong>.',
    main_net_address: 'COS MainNet Address',
    bep2_address: 'BEP2 Address',
    erc20_address: 'ERC-20 Address',
    main_net_token: 'COS MainNet',
    bep2_token: 'COS-BEP2',
    erc20_token: 'COS-ERC20',
    ok: 'Okay',
    Cancel: 'Cancel',
    tips: 'Tips',
    enter_address_tips: '最初に正しいトークンアドレスを入力してください\n',
    enter_exChange_memo_tips: 'Please fill in the exchange memo',
    swap_address_invalid: 'swap address is invalid',
    swap_address_not_exit: 'Account does not exist',
    swap_type_invalid: 'invalid swap type',
    swap_system_error: 'System error occurred. Please try again later.',
    swap_unknown_error: 'Unknown error occurred. Please try again later.',
    swap_memo_invalid: 'Invalid Memo',
    invalid_bnb_exChange_memo_tips: 'Binance exchange memo should be a number',
    paste_warning: '取引所でアドレスを貼り付ける際、上記の内容と一致していることをご確認ください',
    fee_notice: 'ご注意：{token}の変換ごとにガス代として{fee} COSの手数料が差し引かれます。{fee} COS未満の変換リクエストは処理されません。',
    fee_subject_to_change: '手数料は予告なく変更される場合があります',
    view_status: '変換状況を確認',
    prev_step: '戻る',
    go_back: '戻る',
    bep20_address: 'BEP-20 アドレス',
    bep20_token: 'BEP-20 COS',
    token_type_bep20_to_native: 'BEP-20 => メインネット COS',
    token_type_native_to_bep20: 'メインネット COS => BEP-20',
    transfer_prefix_before: 'あなたの',
    transfer_prefix_after: 'を送金先へ',
    copy_memo: 'MEMOをコピー',
    copy_address: 'アドレスをコピー',
    copy_success: 'コピーしました',
    memo_warning: 'ご注意：送金時に正しいMEMOを必ず添付してください。システムは実際の入金額に基づいて変換を行い、ご記入いただいたアドレスへ送金します。MEMOを省略しないでください。',
    col_time: '時間',
    col_target_format: '対象形式',
    col_target_account: '対象アカウント',
    col_amount: '入金額',
    col_status: 'ステータス',
    loading: '読み込み中\u2026',
    no_data: 'データなし',
    next_update_hint: '{time} 後にデータが更新されます',
    status_done: '完了',
    status_pending: '処理中',
    panel_title_status: '変換状況',
    panel_title_step1: 'トークン変換ツール',
    panel_title_step2: 'トークン変換の準備完了',
    panel_subtitle_status: 'ソーストークン形式を選択して変換履歴を確認',
    source_network: 'ソーストークン形式',
    conversion_record: '変換履歴',
    new_label: '新'
  }
}
